import request from '@/utils/request'

// 列表
export function windowsClientList(params = {}) {
  return request({
    url: '/spWorkWechat/windowsClient/index',
    method: 'get',
    params
  })
}

// 创建 入参：ip（integer 必需）
export function windowsClientCreate(data = {}) {
  return request({
    url: '/spWorkWechat/windowsClient/create',
    method: 'post',
    data
  })
}

// 更新  入参:id,ip
export function windowsClientUpdate(data = {}) {
  return request({
    url: '/spWorkWechat/windowsClient/update',
    method: 'post',
    data
  })
}

// 删除  入参:id（integer 必需）
export function windowsClientDestroy(data = {}) {
  return request({
    url: '/spWorkWechat/windowsClient/destroy',
    method: 'post',
    data
  })
}

// 绑定  id（integer 必需）wechat_name （string）
export function bindWechat(data = {}) {
  return request({
    url: '/spWorkWechat/windowsClient/bindWechat',
    method: 'post',
    data
  })
}
// 需要发送的微信list
export function wechatAccepter(params = {}) {
  return request({
    url: '/spWorkWechat/spCorp/contactFollowUsers',
    method: 'get',
    params
  })
}
